import React, { ReactNode } from 'react';
import { Box, Text, Button, PlusIcon } from '@razorpay/blade/components';
import { Link } from 'react-router-dom';
import { NavItemBox } from './styles';

export interface NavItemProps {
  text: ReactNode;
  href: string;
  isActive?: boolean;
  icon?: ReactNode;
}

const NavItem = ({ text, href, isActive, icon }: NavItemProps) => {
  return (
    <Link to={href}>
      <NavItemBox isActive={isActive}>
        {icon && <Box>{icon}</Box>}
        <Text weight={isActive ? 'semibold' : 'regular'}>{text}</Text>
        {isActive && (
          <Box
            height="spacing.7"
            width="spacing.2"
            backgroundColor="surface.background.primary.intense"
            position="absolute"
            left="-2px"
            top="spacing.3"
            borderRadius="small"
          />
        )}
      </NavItemBox>
    </Link>
  );
};

export interface SideNavProps {
  navItems: NavItemProps[];
  onCreateClick?: () => void;
}

const SideNav = ({ navItems, onCreateClick }: SideNavProps) => {
  return (
    <Box as="nav" display="flex" flexDirection="column" gap="spacing.4">
      {onCreateClick && (
        <Box marginBottom="spacing.3">
          <Button icon={PlusIcon} onClick={onCreateClick} isFullWidth size="medium">
            New Flow
          </Button>
        </Box>
      )}
      <Box display="flex" flexDirection="column" gap="spacing.1">
        {navItems.map((navItem, index) => (
          <NavItem {...navItem} key={index} />
        ))}
      </Box>
    </Box>
  );
};

export { SideNav };
